import CustomerDecorator from "./CustomerDecorator";
import OrderDecorator from "./OrderDecorator";

export default class CustomerFullDecorator extends CustomerDecorator {
  transformData(data) {
    return super.transformData({
      ...data,
      orders: data.orders && data.orders.map((o) => new OrderDecorator(o)),
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/CustomerFullDecorator.js